import React from "react";
import { Edit3, Trash2, Ticket, Calendar, Percent, Hash } from "lucide-react";

const IndexRow = ({ voucher }) => (
  <>
    <td className="px-8 py-6 rounded-l-xl">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center shrink-0 border border-blue-100 dark:border-blue-800">
          <Ticket size={20} className="text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <span className="text-xs font-black text-stone-800 dark:text-white uppercase tracking-tight block">
            {voucher.code}
          </span>
          <p className="text-[9px] text-stone-400 font-bold uppercase tracking-widest">{voucher.title}</p>
        </div>
      </div>
    </td>
    <td className="px-6 py-6">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-lg bg-green-100 flex items-center justify-center shrink-0">
          <Percent size={12} className="text-green-700" />
        </div>
        <span className="text-[10px] text-slate-600 dark:text-stone-300 font-bold uppercase tracking-tight">
          {voucher.discountType === 'Percentage' ? `${voucher.discountValue}% OFF` : `IDR ${voucher.discountValue.toLocaleString()}`}
        </span>
      </div>
    </td>
    <td className="px-6 py-6 text-center">
      <div className="flex flex-col items-center gap-1">
        <div className="flex items-center gap-1.5 text-stone-800 dark:text-stone-200 font-bold text-[10px] uppercase tracking-tighter">
          <Calendar size={12} className="text-blue-600" />
          {voucher.expiryDate}
        </div>
        <span className={`text-[8px] font-black uppercase px-2 py-0.5 rounded ${
          voucher.isValid ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
        }`}>
          {voucher.isValid ? 'Active' : 'Expired'}
        </span>
      </div>
    </td>
    <td className="px-6 py-6 text-center">
      <div className="inline-flex items-center gap-1 px-3 py-1 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 rounded-full font-black text-[10px]">
        <Hash size={10} />
        {voucher.usageLimit} Limit
      </div>
    </td>
    <td className="px-6 py-6 text-center font-black text-[11px] text-stone-800 dark:text-stone-200">
      {voucher.usedCount} Redemptions
    </td>
    <td className="px-6 py-6 text-center rounded-r-xl">
      <div className="flex items-center justify-center gap-2">
        <button className="p-2.5 bg-white/50 dark:bg-white/5 hover:bg-blue-100 text-stone-400 hover:text-blue-600 rounded-xl transition-all shadow-sm">
          <Edit3 size={14} />
        </button>
        <button className="p-2.5 bg-white/50 dark:bg-white/5 hover:bg-red-100 text-stone-400 hover:text-red-600 rounded-xl transition-all shadow-sm">
          <Trash2 size={14} />
        </button>
      </div>
    </td>
  </>
);

export default IndexRow;